module.exports = __webpack_public_path__ + "img/ic_mobile_white.c8e58183.svg";